<span class="review-status-icon {{iconDetails.icon}}" [ngStyle]="{'color': iconDetails.color}"></span>
